import { createAnatomy as g } from "../../anatomy/dist/index.mjs";
import { createScope as l, query as n } from "../../dom-query/dist/index.mjs";
var d = g("combobox").parts(
  "root",
  "clearTrigger",
  "content",
  "control",
  "input",
  "item",
  "itemGroup",
  "itemGroupLabel",
  "itemIndicator",
  "itemText",
  "label",
  "list",
  "positioner",
  "trigger"
);
d.build();
var t = l({
  getRootId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.root) ?? `combobox:${e.id}`;
  },
  getLabelId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.label) ?? `combobox:${e.id}:label`;
  },
  getControlId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.control) ?? `combobox:${e.id}:control`;
  },
  getInputId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.input) ?? `combobox:${e.id}:input`;
  },
  getContentId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.content) ?? `combobox:${e.id}:content`;
  },
  getPositionerId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.positioner) ?? `combobox:${e.id}:popper`;
  },
  getTriggerId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.trigger) ?? `combobox:${e.id}:toggle-btn`;
  },
  getClearTriggerId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.clearTrigger) ?? `combobox:${e.id}:clear-btn`;
  },
  getItemGroupId: (e, o) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.itemGroup) == null ? void 0 : i.call(r, o)) ?? `combobox:${e.id}:optgroup:${o}`;
  },
  getItemGroupLabelId: (e, o) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.itemGroupLabel) == null ? void 0 : i.call(r, o)) ?? `combobox:${e.id}:optgroup-label:${o}`;
  },
  getItemId: (e, o) => {
    var r, i;
    return ((i = (r = e.ids) == null ? void 0 : r.item) == null ? void 0 : i.call(r, o)) ?? `combobox:${e.id}:option:${o}`;
  },
  getContentEl: (e) => t.getById(e, t.getContentId(e)),
  getInputEl: (e) => t.getById(e, t.getInputId(e)),
  getPositionerEl: (e) => t.getById(e, t.getPositionerId(e)),
  getControlEl: (e) => t.getById(e, t.getControlId(e)),
  getTriggerEl: (e) => t.getById(e, t.getTriggerId(e)),
  getClearTriggerEl: (e) => t.getById(e, t.getClearTriggerId(e)),
  getHighlightedItemEl: (e) => {
    const o = e.highlightedValue;
    if (o == null) return;
    const r = `[role=option][data-value="${CSS.escape(o)}"`;
    return n(t.getContentEl(e), r);
  },
  focusInputEl: (e) => {
    const o = t.getInputEl(e);
    t.isActiveElement(e, o) || o == null || o.focus({ preventScroll: !0 });
  },
  focusTriggerEl: (e) => {
    const o = t.getTriggerEl(e);
    t.isActiveElement(e, o) || o == null || o.focus({ preventScroll: !0 });
  }
});
export {
  d as anatomy
};
